import {singleton} from "tsyringe";
import {container} from "tsyringe";
import {CommandHandler} from "../../decorators/command-handler.decorator";
import {ICommand} from "../i-command.interface";
import {ICommandHandler} from "./i-command.handler";
import {OpenNewEmployeeDialogCommand} from "../open-new-employee-dialog.command";
import {UiHelper} from "../../helpers/ui.helper";
import {Employee} from "../../domain/entities/employee.entity";
import {AbstractCommand} from "../abstract.command";
import {EntityManager} from "../../persistence/entity.manager";

@CommandHandler(OpenNewEmployeeDialogCommand)
@singleton()
export class OpenNewEmployeeDialogCommandHandler implements ICommandHandler<void> {
    
    public async handle(command: ICommand<void>): Promise<void> {
        const entityManager = container.resolve(EntityManager);
        const employeeRepository = entityManager.getRepositoryForEntity(Employee);
        
        if (!employeeRepository) {
            throw new Error('Employee repository not found');
        }
        
        const employee = await employeeRepository.create();
        
        UiHelper.openDialogEntityEdit<AbstractCommand<Employee>>(
            Employee,
            employee,
            {
                creationMode: true,
                closable: true
            }
        );
    }
}